import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Select as SelectOrigin } from "mui-rff";
import { MenuItem } from "@material-ui/core";

import { styles } from "./Select.styles";

function Select({ classes, id, label, options, required, disabled }) {
  return (
    <div className={classes.root}>
      <SelectOrigin
        className={
          classes.selectfield + (disabled ? " " + classes.disabledSelect : "")
        }
        label={label}
        name={id}
        id={id}
        margin="none"
        size="small"
        required={required}
        MenuProps={{ classes: { paper: classes.selectMenu }, variant: "menu" }}
      >
        {options &&
          options.map((item) => {
            return (
              <MenuItem key={id + "_" + item.value} value={item.value}>
                {item.text}
              </MenuItem>
            );
          })}
      </SelectOrigin>
    </div>
  );
}

export default withStyles(styles)(Select);
